<template>
  <div>
    <div class="head">
      <div style="margin-left: 4%;float: left">Hebe Token Factory</div>
      <div style="float: right;margin-right: 4%">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link" style="color: #fff">
                Tool<i class="el-icon-arrow-down el-icon--right"></i>
           </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="">Home</el-dropdown-item>
            <el-dropdown-item command="faucet">Etc Mordor Faucet</el-dropdown-item>
            <el-dropdown-item command="multisenderetc">Etc MultiSender</el-dropdown-item>
            <el-dropdown-item command="multisenderetc1">Etc Customize MultiSender</el-dropdown-item>
            <el-dropdown-item command="multisendererc20">Erc20 MultiSender</el-dropdown-item>

          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="details">
      <div class="toptitle">
        <div style="margin-left: 20px">
          Etc Erc20 Multi Sender - It is recommended to use a new address for bulk transfers
        </div>
      </div>
      <div style="width: 100%; background: rgb(255, 255, 255);">
        <div style="padding: 40px 20px;padding-top: 10px;">
          <div>
            <el-form v-loading="loading" ref="form" :model="form" :label-position="'top'" label-width="80px">
              <el-form-item label="Chain">
                <el-select @change="selectnetwork" filterable style="width: 98%" v-model="form.chain"
                           placeholder="Select Type of Token">
                  <el-option v-for="item in chains" :key="item.name" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Token Contract">
                <el-input style="width: 98%" v-model="form.token"></el-input>
              </el-form-item>
              <el-form-item label="Token Decimals">
                <el-input style="width: 98%" v-model="form.decimals"></el-input>
              </el-form-item>

              <el-form-item
                label="Send address list（ Please delete the default address, the address is isolated by carriage return ）">
                <el-input :autosize="{ minRows: 4}"
                          type="textarea"
                          v-model="form.addrlist"></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 20px">
                <el-button type="primary" @click="onSubmit">Submit</el-button>
              </el-form-item>
            </el-form>
            <!--            <el-steps v-if="loading" :active="active" finish-status="success">-->
            <!--              <el-step title="Payment"-->
            <!--                       :description="'An amount of '+ sum+' '+type+' will be paid to the  Hebe developers for the generation of the token.'"></el-step>-->
            <!--              <el-step title="Token registration" description="In order to generate the token, some information is required to be provided and the transaction fee needs to be paid."></el-step>-->
            <!--              <el-step title="Finalization of registration"-->
            <!--                       :description="'After the registration is completed, the token will be added to the your given '+type+' Wallet address.'"></el-step>-->
            <!--            </el-steps>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const web3Utils = require('web3-utils')
  const axios = require('axios')
  const BN = require('bignumber.js')

  export default {
    name: 'multisenderetc',
    data() {
      return {
        chains: [
          {
            'name': 'Ethereum Classic Mainnet',
            'chain': 'ETC',
            'rpc': ['https://etc.rivet.link'],
            'faucets': ['https://free-online-app.com/faucet-for-eth-evm-chains/?'],
            'nativeCurrency': {'name': 'Ethereum Classic Ether', 'symbol': 'ETC', 'decimals': 18},
            'infoURL': 'https://ethereumclassic.org',
            'shortName': 'etc',
            'chainId': 61,
            'networkId': 1,
            'slip44': 61,
            'explorers': [{'name': 'blockscout', 'url': 'https://blockscout.com/etc/mainnet', 'standard': 'none'}],
            'token': '0x6F1DB87a18A99f5695B0f42eBd4331EE7F402d77'
          },
          {
            'name': 'Ethereum Classic Testnet Mordor',
            'chain': 'ETC',
            'rpc': ['https://rpc.mordor.etccooperative.org'],
            'faucets': [],
            'nativeCurrency': {'name': 'Mordor Classic Testnet', 'symbol': 'METC', 'decimals': 18},
            'infoURL': 'https://github.com/eth-classic/mordor/',
            'shortName': 'metc',
            'chainId': 63,
            'networkId': 7,
            'explorers': [{'name': 'blockscout', 'url': 'https://blockscout.com/etc/mordor', 'standard': 'none'}],
            'token': '0xA99504ACB9Ba0995083ffce3d9103f3dDF33Ac2f'
          }
        ],
        loading: false,
        form: {
          chain: 'Ethereum Classic Mainnet',
          addr: '',
          type: '',
          token: '',
          decimals: '18',
          sum: '0.01',
          addrlist: '0x4f9C2C75d794F0aDb3BeB3398c5D8c552e4b64ba,1000\ntest.etc,2000\n' +
            '0x2573635A66Fa1192eFCbbF4EF45a796677d99f4b,3000\n0x8828C116Dd7888F3A3Bd65E284E63Fc24Cb00deB,4000'
        }
      }
    },
    methods: {
      handleCommand(command) {
        this.$router.push({path: '/' + command})
      },
      selectnetwork() {
        this.chains.forEach(item => {
          if (this.form.chain == item.name) {
            this.type = item.nativeCurrency.symbol
          }
        })
      },
      async onSubmit() {
        let addrlist = []
        if (this.form.addrlist.indexOf('[') != -1) {
          addrlist = JSON.parse(this.form.addrlist)
        } else {
          let addrlistsplit = this.form.addrlist.split('\n')
          for (let i = 0; i < addrlistsplit.length; i++) {
            let item = addrlistsplit[i]
            if (item.split(',').length == 2) {
              addrlist.push({
                addr: item.split(',')[0].trim(),
                sum: item.split(',')[1].trim(),
              })
            }
          }
        }
        let recipients = []
        let amounts = []

        for (let i = 0; i < addrlist.length; i++) {
          if (addrlist[i].addr.trim().length == 42) {
            recipients.push(addrlist[i].addr);
            amounts.push(BigInt(addrlist[i].sum * Math.pow(10, this.form.decimals)).toString());
          } else {
            let addrhens = await hens.js.getOwner(addrlist[i].addr.trim())
            if (addrhens.length == 41) {
              recipients.push(addrlist[i].addr);
              amounts.push(BigInt(addrlist[i].sum * Math.pow(10, this.form.decimals)).toString());
            }
          }

        }
        if (this.form.addr != '') {
          let network = ''
          this.chains.forEach(item => {
            if (this.form.chain == item.name) {
              network = item
              this.type = item.nativeCurrency.symbol
            }
          })
          let chainId = await ethereum.request({method: 'eth_chainId'})
          if (web3Utils.toHex(network.chainId) != chainId) {
            await this.addEthereumChain(network)
          }
          this.form.addr = await this.getAddr()
          let web3 = new Web3()
          let sum = 0;
          amounts.forEach(item=>{
            sum=BigInt(sum)+BigInt(item)
          })
          let ERC20ABI = require('../multisender/ERC20ABI.json')

          let token = new web3.eth.Contract(ERC20ABI, this.form.token)
          let approve = await token.methods['approve(address,uint256)'](network.token, sum.toString()).encodeABI()
          let transactionParameters = {
            gasPrice: web3Utils.toHex(parseInt(1 * 10e+8)),
            gasLimit: web3Utils.toHex(21000),
            to: this.form.token,
            from: this.form.addr,
            value: '0x0',
            data: approve,
            chainId: web3Utils.toHex(chainId)
          }
          let txHash = await ethereum.request({
            method: 'eth_sendTransaction',
            params: [transactionParameters]
          })
          this.loading = true
          let ttt = await this.eth_getTransactionReceipt(txHash)
          if (ttt == '0x0') {
            this.$message.error('Error')
            this.loading = false
          } else {
            this.loading = false
            console.log(this.form.token);
            let txabi = web3.eth.abi.encodeFunctionCall({
              name: 'batchSendERC20',
              type: 'function',
              inputs: [
                {
                  'name': 'token',
                  'type': 'address'
                },
                {
                  'name': 'recipients',
                  'type': 'address[]'
                },
                {
                  'name': 'amounts',
                  'type': 'uint256[]'
                }
              ]
            }, [this.form.token, recipients, amounts])
            this.loading = true

            let transactionParameters1 = {
              gasPrice: web3Utils.toHex(parseInt(1 * 10e+8)),
              gasLimit: web3Utils.toHex(500000),
              to: network.token,
              from: this.form.addr,
              value: web3Utils.toHex(parseInt(0 * 10e+17)),
              data: txabi,
              chainId: web3Utils.toHex(chainId)
            }
            let txHash1 = await ethereum.request({
              method: 'eth_sendTransaction',
              params: [transactionParameters1]
            })
            this.loading = false

            this.$alert('Transaction：' + txHash1, 'Finish', {
              confirmButtonText: 'Ok',
              callback: action => {
              }
            })

          }

        }
      },
      async eth_getTransactionReceipt(tx) {
        return new Promise(async (resolve, reject) => {
            ethereum.request({
              'method': 'eth_getTransactionReceipt',
              'params': [tx]
            }).then(async (res) => {
              if (res == null) {
                console.log('开始循环')
                setTimeout(() => {
                  resolve(this.eth_getTransactionReceipt(tx))
                }, 3000)
                return
              } else if (res.status) {
                resolve(res.status)
              }
            })
              .catch((err) => {
                console.log(err)
                resolve('')
              })
          }
        )
      },

      async addEthereumChain(model) {
        await ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: web3Utils.toHex(model.chainId),
              rpcUrls: model.rpc,
              chainName: model.name,
              nativeCurrency: {
                name: model.nativeCurrency.name,
                decimals: model.nativeCurrency.decimals,
                symbol: model.nativeCurrency.symbol
              },
              blockExplorerUrls: [model.explorers[0].url]
            }
          ]
        })
      },
      async getAddr() {
        return new Promise(async (resolve, reject) => {
          ethereum
            .request({method: 'eth_requestAccounts'})
            .then((res) => {
              resolve(res[0])
            })
            .catch((err) => {
              resolve('')
            })
        })
      }
    },
    async mounted() {
      this.selectnetwork()
      let _this = this

      async function loginweb3() {
        if (typeof (ethereum) !== 'undefined') {
          _this.form.addr = await _this.getAddr()
          console.log(_this.form.addr)
          _this.$message.success('Connection succeeded')

        } else {
          // _this.$message.error('Please visit in an environment that supports metamask')
          setTimeout(() => {
            loginweb3()
          }, 1000)
        }
      }

      loginweb3()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 0px !important;
  }

  .el-form-item {
    margin-bottom: 6px !important;
  }

  .toptitle {
    border-radius: 0px;
    cursor: pointer;
    box-shadow: rgb(0 0 0 / 10%) 0px 2px 12px 0px;
    margin-top: 10px;
    position: relative;
    background: rgb(250, 250, 250);
    overflow: hidden;
    height: 68px;
    line-height: 68px;
  }

  .details {
    max-width: 1180px;
    margin: 60px auto;
    padding-top: 20px;
  }

  .head {
    line-height: 60px;
    height: 60px;
    width: 100%;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    border-bottom: 1px solid #e5e5e5;
    background: #0299d8;
    background: -webkit-linear-gradient(45deg, #5a3694, #13bdce 33%, #0094d9 66%, #6fc7b5);
    background: -o-linear-gradient(45deg, #5a3694 0, #13bdce 33%, #0094d9 66%, #6fc7b5 100%);
    background: linear-gradient(45deg, #5a3694, #13bdce 33%, #0094d9 66%, #6fc7b5);
    background-size: 400%;
    background-position: 0 100%;
  }

  /* 防止用户自定义背景颜色对网页的影响，添加让用户可以自定义字体 */
  html {
    color: #000;
    background: rgb(240, 246, 250);;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    font-size: 100%;
  }

  /* 内外边距通常让各个浏览器样式的表现位置不同 */
  body, div, dl, dt, dd, ul, li, pre, form, fieldset, select, input, textarea, button, p, blockquote, th, td, img, iframe {
    margin: 0;
    padding: 0;
  }

  body {
    width: 100%;
    font-family: Overpass;
  }

  /* 要注意表单元素并不继承父级 font 的问题 */
  body, button, input, select, textarea {
    outline: none;
  }

  input, select, textarea {
    font-size: 100%;
  }

  /* 重置button边框 */
  button {
    border: none;
  }

  /* 去掉各Table cell 的边距并让其边重合 */
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /* IE bug fixed: th 不继承 text-align*/
  th {
    text-align: inherit;
  }

  /* 对齐是排版最重要的因素, 别让什么都居中 */
  caption, th {
    text-align: left;
  }

  /* 去除默认边框 */
  fieldset, img {
    border: none;
    outline: none;
    -moz-outline: none;
  }

  /* ie6 7 8(q) bug 显示为行内表现 */
  iframe {
    display: block;
  }

  /* 去掉列表前的标识, li 会继承 */
  ol, ul, li {
    list-style: none;
  }

  /* 来自yahoo, 让标题都自定义, 适应多个系统应用 */
  h1, h2, h3, h4, h5, h6 {
    font-size: 100%;
    font-weight: 500;
    margin: 0;
    padding: 0;
  }

  /* 让链接默认不显示下划线，在hover状态下显示下划线 */
  a {
    color: #333;
    cursor: pointer;
    outline: none;
    text-decoration: none;
    blr: expression(this.onFocus=this.blur());
  }

  a:hover {
    text-decoration: underline;
  }

  /* 清理浮动 */
  .clearfix:before, .clearfix:after {
    display: block;
    content: " ";
    clear: both;
  }

  .clearfix {
    zoom: 1; /* for ie67*/
  }

  /* 重设 HTML5 标签, IE 需要在 js 中 createElement(TAG) */
  article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
    display: block;
  }

  /* HTML5 媒体文件跟 img 保持一致 */
  audio, canvas, video {
    display: inline-block;
    *display: inline;
    *zoom: 1;
  }

  address, caption, cite, code, dfn, em, th {
    font-style: normal;
    font-weight: normal;
  }

  /*解决盒模型问题css3属性也可用来统一FORM元素风格*/
  .box-sizing {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/multisendererc201.vue